export default __webpack_public_path__ + "images/groupem-stone-0.svg";